import React from 'react';
import PropTypes from 'prop-types';
import { Collapsible, CollapsibleContent, CollapsibleHeader } from '../../../../../components/Collapsible';
import { FilterYear, FilterYearForm } from '../../Filter';

const CollapsibleYear = ({position, label, min, max, handleDataChange, isThreeColumnLayout}) => {
  let FilterYearComponent;
  let extraFilterProps = {};
  if (position !== 'desktop') {
    FilterYearComponent = FilterYear;
    extraFilterProps = {
      isThreeColumnLayout,
      position,
    };
  } else {
    FilterYearComponent = FilterYearForm;
  }
  return (<CollapsibleContent initialState="open">
    <CollapsibleHeader priority={0}>{label}</CollapsibleHeader>
    <Collapsible>
      <FilterYearComponent
        min={min}
        max={max}
        handleDataChange={handleDataChange}
        {...extraFilterProps}
      />
    </Collapsible>
  </CollapsibleContent>);
};

CollapsibleYear.propTypes = {
  position: PropTypes.string,
  label: PropTypes.string,
  min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  handleDataChange: PropTypes.func,
  isThreeColumnLayout: PropTypes.bool,
};

export { CollapsibleYear };
